import { createApiAction } from '@app/packages/api/utils'
import type { V3GetTrainingPaymentContractResponse, V3PostTrainingPaymentContractSettlementResponse } from '@app/packages/api/v3/types/responses'

export const getTrainingPaymentContract = () =>
  createApiAction('getTrainingPaymentContract', dispatch =>
    dispatch<V3GetTrainingPaymentContractResponse>({
      endpoint: '/api/v3/training_payment_contract',
      method: 'GET',
    })
  )

/** «Закрыть сразу»: one bill for the whole remainder. `422` when the offer is no longer on. */
export const postTrainingPaymentContractSettlement = () =>
  createApiAction('postTrainingPaymentContractSettlement', dispatch =>
    dispatch<V3PostTrainingPaymentContractSettlementResponse>({
      endpoint: '/api/v3/training_payment_contract/settlement',
      method: 'POST',
    })
  )
